import {
  actionCreator,
  checkHttpStatus,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  ProgramActionTypes,
  GET_PROGRAM_LIST_API,
  POST_PROGRAM_API,
  GET_PROGRAM_DETAILS_API,
  GET_PROGRAM_DETAILS_BY_DOMAIN_API,
  DELETE_PROGRAM_API,
  PROGRAM_STATUS_ACTIVATION,
} from '../constants/ApiConstants';
import { createSearchUrlForCustomAPI, showWarningMessage } from '../../../../../../actions/utilAction';


export const getProgramList = (searchObj, domainId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ProgramActionTypes.get_programList.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_PROGRAM_LIST_API}${query_params}&domainId=${domainId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(ProgramActionTypes.get_programList.SUCCESS, response));
        } else {
          dispatch(actionCreator(ProgramActionTypes.get_programList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_programList ', error);
      });
  };
};

export const saveProgram = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ProgramActionTypes.post_program.REQUEST));
    fetch(POST_PROGRAM_API, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(ProgramActionTypes.post_program.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(ProgramActionTypes.post_program.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_program', error);
      });
  };
};

export const getProgramDetails = (programID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ProgramActionTypes.get_programDetails.REQUEST));
    fetch(`${GET_PROGRAM_DETAILS_API}?programId=${programID}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(ProgramActionTypes.get_programDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(ProgramActionTypes.get_programDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_programDetails ', error);
      });
  };
};


export const getProgramDetailsByDomain = (domainID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ProgramActionTypes.get_programDetailsByDomain.REQUEST));
    fetch(`${GET_PROGRAM_DETAILS_BY_DOMAIN_API}?domainId=${domainID}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(ProgramActionTypes.get_programDetailsByDomain.SUCCESS, response));
        } else {
          dispatch(actionCreator(ProgramActionTypes.get_programDetailsByDomain.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_programDetailsByDomain ', error);
      });
  };
};

export const deleteProgram = (programID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ProgramActionTypes.delete_program.REQUEST));
    fetch(`${DELETE_PROGRAM_API}?programId=${programID}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 200 || response.statusCode === 204) { 
          showSuccessMessage(response.message);
          dispatch(actionCreator(ProgramActionTypes.delete_program.SUCCESS, response));
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(ProgramActionTypes.delete_program.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(ProgramActionTypes.delete_program.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error delete_program', error);
      });
  };
};

export const updateProgramActiveStatus = (programId, IsActivate, domainId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ProgramActionTypes.program_active_status.REQUEST));
    fetch(`${PROGRAM_STATUS_ACTIVATION}?programId=${programId}&isActive=${IsActivate}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(ProgramActionTypes.program_active_status.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(ProgramActionTypes.program_active_status.SUCCESS, {}));
        }

        let searchObj = {
          sort_fields: '',
          sort_order: '',
          contain_filters: { SearchText: null },
          pageNumber: 1,
        };
        dispatch(getProgramList(searchObj, domainId));
      })
      .catch(function(error) {
        console.log('error-----', error);
        dispatch(actionCreator(ProgramActionTypes.program_active_status.SUCCESS, {}));
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/program/actions/programActions.js